import axios from 'axios';

const getItensCarrinho = params => axios.get('/carrinho', {
  params,
});

const adicionarRestposta = id => axios.post(`/carrinho/resposta/${id}`, {});
const adicionarProduto = id => axios.post(`/carrinho/resposta-produto/${id}`, {});
const adicionarTodosProdutos = ids => axios.post('/carrinho/resposta-produto/all', ids);
const removerProduto = id => axios.delete(`/carrinho/produto/${id}`, {});
const removerResposta = id => axios.delete(`/carrinho/${id}`, {});
const finalizar = json => axios.post('/carrinho/finalizar', json);

export default {
  adicionarTodosProdutos,
  getItensCarrinho,
  adicionarProduto,
  adicionarRestposta,
  removerProduto,
  removerResposta,
  finalizar,
};
